import { createAction } from 'redux-act';
import { createResource } from '@gandi/resource/redux';
import { localeSelector } from '@gandi/translate';
import { logging } from 'gandi.redux-logger';
const loggerNamespace = '@gandi/domain-configuration';
export const extrasResource = createResource('extras');
export const tldsInfoResource = createResource('tldsInfo');
export const validForResource = createResource('validFor');
export const fetchExtraParamsStart = createAction('[DomainContacts] Start to fetch extra parameters');
export const fetchExtraParamsEnd = createAction('[DomainContacts] End to fetch extra parameters');
export const fetchTldInfo = fqdn => dispatch => {
  const logger = logging(dispatch, loggerNamespace);
  const url = `/domain/tlds/${fqdn}`;
  return dispatch(tldsInfoResource.fetch(url, {
    label: `tlds/${fqdn}`,
    fqdn,
    not200: response => {
      logger.error({
        res: response
      }, `Cannot get tld info of ${fqdn}`);
      return Promise.reject(response);
    },
    on500: err => {
      throw new Error(err);
    }
  }));
};
export const fetchDomainExtraParams = (domainInfo, role, contactType) => (dispatch, getState) => {
  const lang = localeSelector(getState());
  const url = '/contactvalidation/extras';
  const logger = logging(dispatch, loggerNamespace);
  const {
    tld,
    phase
  } = domainInfo;
  const type = contactType;
  return dispatch(extrasResource.fetch(url, {
    label: `extras/${tld}`,
    query: {
      tld,
      roles: [role],
      type,
      phase,
      lang
    },
    not200: response => {
      logger.error({
        res: response
      }, `Cannot fetch extraparams for ${tld}`);
      return Promise.reject(response);
    },
    on500: err => {
      throw new Error(err);
    }
  }));
};
export const validateContactValues = ({
  fqdn,
  role,
  process
}, values, roles) => dispatch => {
  const url = `/contactvalidation/validfor/${fqdn}`;
  const params = {
    ...values,
    roles: roles || [role]
  };
  return dispatch(validForResource.createOne(url, params, {
    params: {
      process
    },
    label: `validfor/${fqdn}`,
    fqdn,
    role,
    values,
    roles
  }));
};
export const validateOwnerContactValues = ({
  fqdn
}, values) => dispatch => {
  const url = `/contactvalidation/validfor/${fqdn}/contacts/owner`;
  return dispatch(validForResource.createOne(url, values, {
    label: `validfor/${fqdn}`,
    fqdn,
    role: 'owner',
    values
  }));
};